import { type IncomingMessage, MessageHandler } from '@carvana/merch-native';
import { useContext, useEffect, useMemo, useState } from 'react';
import UserVehicleContext from '~/context/vdp/UserVehicleContext';
import useGetStarted from '~/hooks/vdp/cta/useGetStarted';
import { ListenerEvent, type ListenerEventType } from './constants';

type StartPurchasePayload = {};

function isStartPurchaseMessage(
  message: IncomingMessage<ListenerEventType, any>
): message is IncomingMessage<ListenerEventType, StartPurchasePayload> {
  return message.event === ListenerEvent.StartPurchase;
}

export default function useStartPurchaseHandler(): MessageHandler<
  ListenerEventType,
  StartPurchasePayload
> {
  const [shouldStartPurchase, setShouldStartPurchase] = useState(false);
  const startPurchase = useGetStarted(0);
  const {
    rcbPurchasing: { isLoaded: isPurchasingLoaded }
  } = useContext(UserVehicleContext);

  useEffect(() => {
    if (!shouldStartPurchase || !isPurchasingLoaded) return;

    void startPurchase();
    setShouldStartPurchase(false);
  }, [isPurchasingLoaded, shouldStartPurchase, startPurchase]);

  return useMemo(
    () =>
      new MessageHandler(isStartPurchaseMessage, () => {
        setShouldStartPurchase(true);
      }),
    []
  );
}
